export const AUTH_TOKEN = 'lumii_at';
export const AUTH_CODE = 'lumii';
